/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiationBeamParameter from './radiation-beam-parameter';
import RadiationBeamParameterDetail from './radiation-beam-parameter-detail';
import RadiationBeamParameterUpdate from './radiation-beam-parameter-update';
import RadiationBeamParameterDeleteDialog from './radiation-beam-parameter-delete-dialog';

const RadiationBeamParameterRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiationBeamParameter />} />
    <Route path="new" element={<RadiationBeamParameterUpdate />} />
    <Route path=":id">
      <Route index element={<RadiationBeamParameterDetail />} />
      <Route path="edit" element={<RadiationBeamParameterUpdate />} />
      <Route path="delete" element={<RadiationBeamParameterDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiationBeamParameterRoutes;
